import React, { useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import TutorSidebar from '../../../TutorSidebar/TutorSidebar'
import { useDispatch, useSelector } from 'react-redux';
import { getTutorCompletedAssStudentDetail } from '../../../../../Redux/action/TutorAction';
import Beatloader from '../../../../../Common/BeatLoader';
import { useFormik } from 'formik';
import * as Yup from "yup";
import axios from 'axios';
import toast from 'react-hot-toast';

const host = process.env.REACT_APP_API_SERVER

const TutorSubjectiveTestUpdate = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const assessment_id = location?.state?.assessment_id;
    const student_id = location?.state?.student_id;

    useEffect(() => {
        if (assessment_id && student_id) {
            console.log('Dispatching action with:', { assessment_id, student_id });
            dispatch(getTutorCompletedAssStudentDetail(assessment_id, student_id));
        } else {
            console.log('Redirecting to the previous page');
            navigate(-1);
        }
    }, [assessment_id, student_id, dispatch, navigate]);

    const {
        loadingTutorCompletedAssStudentDetailApi,
        TutorCompletedAssStudentDetailApiData,
        TutorCompletedAssStudentDetailApiError

    } = useSelector(state => state?.TutorReducer);



    const questionList = TutorCompletedAssStudentDetailApiData?.assessment?.subjective_questions?.[0]?.question_and_marks ? JSON.parse(TutorCompletedAssStudentDetailApiData?.assessment?.subjective_questions?.[0]?.question_and_marks) : []

    const validationSchema = Yup.object({
        answerList: Yup.array().of(
            Yup.object({
                question_no: Yup.number().required(),
                marks: Yup.number().required(),
                obtained_mark: Yup.number()
                    .required('Marks are required')
                    .min(0, 'Marks cannot be less than 0')
                    .max(Yup.ref('marks'), 'Marks cannot exceed max marks'),
            })
        ),
    });

    const formik = useFormik({
        initialValues: {
            assessment_id: assessment_id,
            student_id: student_id,
            answerList: questionList?.map((q) => ({
                question_no: Number(q.question_no),
                marks: Number(q.marks),
                obtained_mark: null, // Start with empty obtained marks
            })),
        },
        validationSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {

                setSubmitting(true);
                const config = {
                    headers: {

                        "x-auth-token": localStorage.getItem('tutor-token'),
                    },
                }
                const response = await axios.post(`${host}/api/tutor/mark-upload-sub-assessment`, values, config);

                if (response.status == 200) {
                    setSubmitting(false);
                    toast.success("Marks updated successfully");
                    resetForm();
                    navigate('/tutor/completed-assessment')

                } else {
                    setSubmitting(false);
                    toast.error(response.data.message);
                }
            } catch (error) {
                setSubmitting(false);
                console.error("Error:", error);
                toast.error('Error submitting form. Please try again.');
            }
        },
    });

    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Subjective Test
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {loadingTutorCompletedAssStudentDetailApi ?
                                    <Beatloader />
                                    :
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="row mb-3">
                                            <div className="col-lg-12">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h5 className="mb-3">Download Test</h5>
                                                        <div className="row">
                                                            <div className="col-lg-6">
                                                                <h5 className="mb-0">{TutorCompletedAssStudentDetailApiData?.assessment?.assesment_name}</h5>
                                                            </div>
                                                            <div className="col-lg-6 d-flex justify-content-end">
                                                                <a
                                                                    target='blank'
                                                                    href={`${host}/${TutorCompletedAssStudentDetailApiData?.assessment?.subjective_questions?.[0]?.file}`}
                                                                    download="subjective-test"
                                                                    className="btn btn-success"
                                                                >
                                                                    Download
                                                                </a>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {questionList?.length > 0 ?
                                            questionList?.map((data, index) => (
                                                <div className="row mb-3">
                                                    <div className="col-lg-4 col-md-4 mb-3">
                                                        <div className="card bg-light">
                                                            <div className="card-body">
                                                                <h6 className="mb-2">Question : {index + 1}</h6>
                                                                <h5 className="fw-bold">{data?.question_no}</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-4 mb-3">
                                                        <div className="card">
                                                            <div className="card-body">
                                                                <h6 className="mb-2">Max. Marks</h6>
                                                                <h5 className="fw-bold">{data?.marks}</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-4 mb-3">
                                                        <div className="card">
                                                            <div className="card-body">
                                                                <h6 className="mb-2">Obtained Marks</h6>
                                                                <input
                                                                    type="number"
                                                                    className="border-0 w-100 mb-1"
                                                                    name={`answerList[${index}].obtained_mark`}
                                                                    value={formik.values.answerList[index]?.obtained_mark}
                                                                    onChange={formik.handleChange}
                                                                />

                                                            </div>
                                                        </div>
                                                        {formik.errors.answerList &&
                                                            formik.errors.answerList[index] &&
                                                            formik.errors.answerList[index]?.obtained_mark && (
                                                                <div className="text-danger">
                                                                    {formik.errors.answerList[index]?.obtained_mark}
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                            ))
                                            :
                                            <div className='no-data-img'>
                                                <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                            </div>
                                        }

                                        <div className="row">
                                            <div className="col-lg-3">
                                                {/* <Link to="/tutor/completed-assessment"> */}
                                                <button type='submit' className="btn btn-primary w-100">Submit</button>
                                                {/* </Link> */}
                                            </div>
                                        </div>
                                    </form>
                                }
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorSubjectiveTestUpdate